export default "__VITE_ASSET__B7hkS0lz__"